import { render, staticRenderFns } from "./sthi2.vue?vue&type=template&id=435eba5a&scoped=true&"
import script from "./sthi2.js?vue&type=script&lang=js&"
export * from "./sthi2.js?vue&type=script&lang=js&"
import style0 from "./sthi2.css?vue&type=style&index=0&id=435eba5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435eba5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VProgressCircular})
